const loadSignal = currentHref => {
  const script = document.createElement("script");
  const SIGNAL_SITE_ID = "ydg7T9K";
  script.src = `https://s.btstatic.com/tag.js#site=${SIGNAL_SITE_ID}&referrer=${encodeURIComponent(
    currentHref
  )}`;
  script.async = true;
  const [firstScript] = document.getElementsByTagName("script");
  firstScript.parentNode.insertBefore(script, firstScript);
};

export default loadSignal;
